<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <ubraniaMenu></ubraniaMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Zestawy asekuracyjne</h4>
              <Link :href="route('bhp.zestawy.asekuracyjne')" class="btn btn-outline-primary btn-sm me-3">
                <i class="bi bi-arrow-left me-2"></i>Powrót
              </Link>
              <button v-if="hasPermission('canEditUbrania')" @click="addNewElement" class="btn btn-success btn-sm me-3">
                <i class="bi bi-plus-circle me-2"></i>Dodaj element zestawu
              </button>
            </div>
          </div>
        </div>

        <div class="widget-content">
          <div class="col-md-6 mb-4">
            <div class="card h-100 shadow-sm">
              <div class="card-body">

                <div class="row">
                  <div class="col-md-12">
                    <div v-if="addingNewElement" class="row mb-3">
                      <div class="col-md-4 col-lg-4 mb-3">
                        <label class="form-label" for="rodzaj">Rodzaj:</label>
                        <select v-model="newElement.rodzaj" class="form-select form-select-sm" style="min-width:200px;">
                          <option disabled value="">-- Wybierz rodzaj --</option>
                          <option value="1">Szelki</option>
                          <option value="2">Lina</option>
                          <option value="3">Zatrzaśnik</option>
                        </select>
                      </div>
                      <div class="col-md-4 col-lg-4 mb-3">
                        <label class="form-label" for="ElementSeria">Nr serii:</label>
                        <input id="ElementSeria" v-model="newElement.nr_seryjny" type="text" class="form-control"
                               style="border-radius: 0;"/>
                      </div>
                      <div class="col-md-4 col-lg-4 mb-3">
                        <label class="form-label" for="ElementData">Data produkcji:</label>
                        <input id="ElementData" v-model="newElement.data_produkcji" type="date" class="form-control"
                               style="border-radius: 0;"/>
                      </div>
                      <div class="modal-footer">
                        <button @click="saveElement" class="btn btn-sm btn-outline-success me-2"><i
                            class="bi bi-save me-2"></i>Zapisz
                        </button>
                        <button @click="cancelNewElement" class="btn btn-sm btn-outline-primary"><i
                            class="bi bi-x-circle me-2"></i>Anuluj
                        </button>
                      </div>
                    </div>

                    <div v-if="editingElementId === editedElement.id" class="row mb-3">
                      <div class="col-md-4 col-lg-4 mb-3">
                        <label class="form-label" for="rodzaj">Rodzaj:</label>
                        <select v-model="editedElement.rodzaj" class="form-select form-select-sm"
                                style="min-width:200px;">
                          <option value="1">Szelki</option>
                          <option value="2">Lina</option>
                          <option value="3">Zatrzaśnik</option>
                        </select>
                      </div>
                      <div class="col-md-4 col-lg-4 mb-3">
                        <label class="form-label" for="seria">Nr serii:</label>
                        <input id="seria" v-model="editedElement.nr_seryjny" type="text" class="form-control"
                               style="border-radius: 0;"/>
                      </div>
                      <div class="col-md-4 col-lg-4 mb-3">
                        <label class="form-label" for="produkcja">Data produkcji:</label>
                        <input id="produkcja" v-model="editedElement.data_produkcji" type="date" class="form-control"
                               style="border-radius: 0;"/>
                      </div>
                      <div class="modal-footer">
                        <button @click="updateElement(editedElement)" class="btn btn-sm btn-outline-success me-2"><i
                            class="bi bi-save me-2"></i>Zapisz
                        </button>
                        <button @click="cancelEditElement" class="btn btn-sm btn-outline-primary"><i
                            class="bi bi-x-circle me-2"></i>Anuluj
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>#</th>
                      <th @click="setSort('rodzaj')" style="cursor:pointer">
                        Rodzaj
                        <i v-if="sort.key==='rodzaj'" :class="sortIcon"></i>
                      </th>
                      <th @click="setSort('nr_seryjny')" style="cursor:pointer">
                        Numer serii
                        <i v-if="sort.key==='nr_seryjny'" :class="sortIcon"></i>
                      </th>
                      <th @click="setSort('data_produkcji')" style="cursor:pointer">
                        Data produkcji
                        <i v-if="sort.key==='data_produkcji'" :class="sortIcon"></i>
                      </th>
                      <th>Akcje</th>
                    </tr>
                    <tr>
                      <th></th>
                      <th>
                        <select v-model="filters.rodzaj" class="form-select form-select-sm">
                          <option value="">Wszystkie</option>
                          <option value="1">Szelki</option>
                          <option value="2">Lina</option>
                          <option value="3">Zatrzaśnik</option>
                        </select>
                      </th>
                      <th>
                        <input v-model="filters.nr_seryjny" type="text" class="form-control form-control-sm"
                               placeholder="Szukaj...">
                      </th>
                      <th></th>
                      <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(element, index) in filteredAndSorted" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ SelectRodzaj(element.rodzaj) }}</td>
                      <td>{{ element.nr_seryjny }}</td>
                      <td>{{ formatDate(element.data_produkcji) }}</td>
                      <td class="text-center" style="width:80px;">
                        <button v-if="editingElementId === element.id" @click="updateElement(element)"
                                class="btn btn-sm btn-success me-2 mb-2">Zapisz
                        </button>
                        <button @click="editElement(element)" class="btn btn-sm btn-outline-info me-2 mb-2"><i
                            class="bi bi-pencil me-2"></i>Edytuj
                        </button>
                        <br>
                        <button @click="deleteElement(element.id)" class="btn btn-sm btn-danger"><i
                            class="bi bi-trash me-2"></i>Usuń
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import ubraniaMenu from "@/Pages/BHP/parts/ubraniaMenu.vue";
import {Link} from "@inertiajs/vue3";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();

export default {
  props: {
    elementy: Array
  },
  data() {
    return {
      hasPermission,
      editingElementId: null,
      editedElement: {},
      addingNewElement: false,
      newElement: this.getEmptyFormElement(),
      filters: {
        nr_seryjny: "",
        rodzaj: ""
      },
      sort: {
        key: "nr_seryjny",
        order: "asc"
      }
    };
  },
  computed: {
    filteredAndSorted() {
      let result = [...this.elementy];

      if (this.filters.nr_seryjny) {
        result = result.filter(el =>
            el.nr_seryjny.toLowerCase().includes(this.filters.nr_seryjny.toLowerCase())
        );
      }
      if (this.filters.rodzaj) {
        result = result.filter(el => String(el.rodzaj) === String(this.filters.rodzaj));
      }

      result.sort((a, b) => {
        let valA = a[this.sort.key];
        let valB = b[this.sort.key];
        if (this.sort.key === "data_produkcji") {
          valA = new Date(valA);
          valB = new Date(valB);
        }
        if (this.sort.key === "rodzaj") {
          valA = this.SelectRodzaj(valA);
          valB = this.SelectRodzaj(valB);
        }
        if (valA < valB) return this.sort.order === "asc" ? -1 : 1;
        if (valA > valB) return this.sort.order === "asc" ? 1 : -1;
        return 0;
      });
      return result;
    },
    sortIcon() {
      return this.sort.order === "asc" ? "bi bi-caret-up-fill" : "bi bi-caret-down-fill";
    }
  },
  components: {AppLayout, Link, ubraniaMenu},
  methods: {
    setSort(key) {
      if (this.sort.key === key) {
        this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
      } else {
        this.sort.key = key;
        this.sort.order = "asc";
      }
    },
    SelectRodzaj(rodzaj) {
      switch (Number(rodzaj)) {
        case 1:
          return 'Szelki';
        case 2:
          return 'Lina';
        case 3:
          return 'Zatrzaśnik';
        default:
          return '';
      }
    },
    updateElement(element) {
      this.editedElement = {...element};
      this.$inertia.put(route('bhp.zestawy_asekuracyjne.element.update', element.id), element, {
        onSuccess: () => {
          this.editingElementId = null;
        }
      });
    },
    addNewElement() {
      this.addingNewElement = true;
      this.newElement = this.getEmptyFormElement();
    },
    cancelNewElement() {
      this.addingNewElement = false;
      this.newElement = this.getEmptyFormElement();
    },
    saveElement() {
      this.$inertia.post(route('bhp.zestawy_asekuracyjne.element.dodaj'), this.newElement, {
        onSuccess: () => {
          this.newElement = this.getEmptyFormElement();
          this.addingNewElement = false;
        }
      });
    },
    deleteElement(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie elementu zestawu asekuracyjnego',
        html: 'Czy na pewno chcesz usunąć wybrany element?',
        showDenyButton: true,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('bhp.zestawy_asekuracyjne.element.usun', id));
        }
      })
    },
    cancelEditElement() {
      this.editingElementId = null;
    },
    editElement(element) {
      this.editingElementId = element.id;
      this.editedElement = {...element};
    },
    getEmptyFormElement() {
      return {
        id: null,
        rodzaj: '',
        nr_seryjny: '',
        data_produkcji: '',
      };
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("pl-PL");
    },
    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  },
};
</script>

<style scoped>
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}

.text-start {
  text-align: left;
}

table th, table td {
  min-width: 50px;
  height: 32px;
}
</style>
